import {
    IntegratedFiltering,
    IntegratedPaging,
    IntegratedSorting,
    PagingState,
    SortingState,
    TableColumnResizing,
} from '@devexpress/dx-react-grid';
import {
    DragDropProvider,
    Grid,
    PagingPanel,
    Table,
    TableColumnReordering,
    TableHeaderRow,
} from '@devexpress/dx-react-grid-material-ui';
import Divider from '@material-ui/core/Divider';
import MenuItem from '@material-ui/core/MenuItem';
import Tooltip from '@material-ui/core/Tooltip';
import { LinearProgress } from 'material-ui';
import CheckIcon from 'material-ui-icons/Check';
import Paper from 'material-ui/Paper';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Link from 'react-router-dom/Link';
import { reduxForm } from 'redux-form';
import getReportTypes from '../../../actions/getReportTypes';
import search from '../../../actions/search';
import updatePerson from '../../../actions/updatePerson';
import compareCaseInsensitive from '../../../helpers/CompareCaseInsensitive';
import SimpleMenu from '../../../helpers/SimpleMenu';
import SkeletonTableRows from '../../../helpers/SkeletonTableRows';
import TableFilters from '../../../helpers/TableFilters';
import { cacheTableOptions, getTableOptions, filterUsersByProduct, filterCustomersByProduct, filterLocationsByProduct, filterPersonLocationsByProduct, isUserATSysAdmin } from '../../../helpers/Util';
import Layout from '../../Layout';
import RenderDialog from '../../../helpers/RenderDialog';

import { ProductMap } from '../../../helpers/ProductMap';
import getCustomers from '../../../actions/getCustomers';
import getCustomerGroups from '../../../actions/getCustomerGroups';
import { isSysAdmin } from '../../../helpers/security/roles';
import OverflowTip from '../../../helpers/OverflowTip';
import {
    Clear as InactiveIcon
} from '@material-ui/icons';


const componentKey = 'user-list';
const paperStyle = {
    width: '80%',
    height: '70%',
    display: 'inline-block',
    margin: 20,
    marginTop: '4vh'
};

class UserList extends Component {
    constructor(props) {
        super(props);

        const columns = [
            { name: 'isActive', title: 'Active' },
            { name: 'email', title: 'Username / Email' },
            { name: 'firstName', title: 'First Name' },
            { name: 'lastName', title: 'Last Name' },
            { name: 'suffix', title: 'Suffix' },
            { name: 'menu', title: ' ' },
        ];
        const skeletonRows = SkeletonTableRows({ columns: columns, rowKey: 'personId' });

        this.state = {
            addLink: '/add-edit-user',
            anchorEl: null,
            columns: columns,
            columnOrder: ['isActive', 'email', 'firstName', 'lastName', 'suffix', 'menu'],
            columnWidths: [
                { columnName: 'isActive', width: '6.67%' },
                { columnName: 'email', width: '50%' },
                { columnName: 'firstName', width: '19.33%' },
                { columnName: 'lastName', width: '19.33%' },
                { columnName: 'suffix', width: '10.67%' },
                { columnName: 'menu', width: '21.33%' },
            ],
            currentPage: 0,
            allItems: [],
            filterByOptions: undefined,
            initialValues: {},
            loading: false,
            pageSize: 10,
            pageSizes: [5, 10, 0],
            rows: skeletonRows,
            searchByOptions: [
                { name: 'email', label: 'Username / Email' },
                { name: 'firstName', label: 'First Name' },
                { name: 'lastName', label: 'Last Name' },
                { name: 'suffix', label: 'Suffix' },
            ],
            sorting: [{ columnName: 'email', direction: 'asc' }],
            tableColumnExtensions: [],
            title: 'Users',
            allCustomers: [],
            allLocations: [],
            allPersons: [],
            allPersonLocations: [],
            productFilterOptions: [
                { name: 'all', label: 'All' },
                { name: 'aci', label: 'AutoCheck Insurance' },
                { name: 'aca', label: 'AutoCheck Auctions' },
                { name: 'vxc', label: 'VIN Cross Check' },
            ],
            message: '',
            openDialog: false,
            refreshed: false
        };
    }

    async componentDidMount() {
        this.setState({ refreshed: true });
        if (this.props.customers && this.props.customers.customers.length > 0) {
            this.getUserData();
        } else {
            await this.props.actions.getUserData(this.props.config);
            this.getUserData();
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.customers !== this.props.customers || this.props.persons !== prevProps.persons) {
            if (this.props.customers && this.props.customers.customers.length > 0) {
                this.getUserData();
            }
        }
    }

    getUserData = async () => {
        if (this.props.locationsList && this.props.locationsList.data.length > 0) {
            if (this.props.persons && this.props.customers && this.props.locationsList) {
                await this.props.actions.getUsers(this.props.config, this.props.customers.customers, this.props.locationsList.data, this.props.persons, this);
            }
        }
    }

    reapplyTableOptions = () => {
        const tableOptions = getTableOptions(componentKey);
        if (!tableOptions) return;

        this.setState({ ...tableOptions });
        this.changeFilters(tableOptions.initialValues);
    };

    rowMapper = (row) => ({
        isActive: (row.isActive === undefined || row.isActive === null) ? true : row.isActive,
        ...row,
    });

    getRowId = (row) => {
        return row.personId;
    };

    changeCurrentPage = (currentPage) => {
        cacheTableOptions(componentKey, { currentPage });
        this.setState({ currentPage });
    };

    changePageSize = (pageSize) => {
        cacheTableOptions(componentKey, { pageSize });
        this.setState({ pageSize });
    };

    changeColumnOrder = (columnOrder) => {
        cacheTableOptions(componentKey, { columnOrder });
        this.setState({ columnOrder });
    };

    changeColumnWidths = (columnWidths) => {
        cacheTableOptions(componentKey, { columnWidths });
        this.setState({ columnWidths });
    };

    changeFilters = (filters) => {
        if (!filters) return;
        const isATSysAdmin = isUserATSysAdmin(localStorage.getItem('customerId'));
        const { searchBy, searchData, filterBy, filterByProduct } = filters;

        let filteredPersons = this.state.allItems;
        if (filterByProduct) {
            const filteredCustomers = filterCustomersByProduct(filterByProduct, this.state.allCustomers, localStorage.getItem('customerId'), isATSysAdmin);
            const filteredLocations = filterLocationsByProduct(this.state.allLocations, filteredCustomers);
            const filteredPersonLocations = filterPersonLocationsByProduct(this.state.allPersonLocations, filteredLocations);
            filteredPersons = filterUsersByProduct(this.state.allPersons, this.state.allPersonLocations, filteredPersonLocations, isATSysAdmin);
            this.setState({ allItems: filteredPersons });
        }

        let filteredRows = filteredPersons.map(this.rowMapper);

        if (searchBy && searchData) {
            filteredRows = filteredRows
                .filter(cg =>
                    cg[searchBy] &&
                    cg[searchBy].toLowerCase().includes(searchData.toLowerCase())
                );
        }

        if (filterBy && filterBy !== 'all') {
            if (filterBy === 'active') {
                filteredRows = filteredRows.filter(cg => cg.isActive);
            } else if (filterBy === 'inactive') {
                filteredRows = filteredRows.filter(cg => !cg.isActive);
            }
        }

        cacheTableOptions(componentKey, filters);
        this.setState({ rows: filteredRows });
    };

    changeSorting = (sorting) => {
        if (!sorting || !sorting.length) return;

        const sortBy = sorting[0].columnName;
        const sortDirection = sorting[0].direction;
        const sortedRows = [...this.state.rows]
            .sort((a, b) => compareCaseInsensitive(a[sortBy], b[sortBy], sortDirection));

        cacheTableOptions(componentKey, { sorting });
        this.setState({ rows: sortedRows, sorting });
    };

    cell = ({ column, style, tableRow, value }) => {
        if (tableRow.row.isSkeletonRow) {
            return <Table.Cell style={style}>{value}</Table.Cell>;
        }

        let content = <OverflowTip value={value}>{value}</OverflowTip>;

        if (column.name === 'menu') {
            content = this.renderMoreMenu(tableRow);
        } else if (column.name === 'isActive') {
            const className = (value || value === undefined) ? 'active-1' : 'active-3';
            let active = (value || value === undefined) ? true : false;
            content = (<Tooltip title={value ? 'Active' : 'Inactive'} placement="left">
                {active ? <CheckIcon className={className} /> : <InactiveIcon className={className} />}
            </Tooltip>);
        }

        return <Table.Cell style={style}>{content}</Table.Cell>;
    };

    renderMoreMenu = (tableRow) => {
        const { row: { personId, cognitoId, isActive } } = tableRow;

        return (
            <SimpleMenu id={personId}>
                <MenuItem
                    key="edit-user"
                    component={Link}
                    to={`/add-edit-user/${cognitoId}`}
                >
                    Edit User
                </MenuItem>
                <MenuItem
                    key="list-users-by-location"
                    component={Link}
                    to={`/locations/user/${personId}`}
                >
                    View Locations
                </MenuItem>
                {/* <Divider />
                <MenuItem
                    key="deactivate"
                    component={Link}
                    to={this.props.location.pathname}
                    onClick={() => this.handleToggleIsActive(personId, isActive)}
                >
                    {isActive ? 'Deactivate' : 'Activate'}
                </MenuItem> */}
            </SimpleMenu>
        );
    };

    handleToggleIsActive = (id, isActive) => {
        const person = this.state.allItems.find(cg => cg.personId === id);

        person.isActive = !isActive;

        if (isActive === false && person.customerRecordDisabled === true) {
            this.setState({ openDialog: true, message: "Customer account is deactivated" });

            return;
        }
        else if (person.isActive) {
            person['activatedOnUserScreen'] = true;
        }
        else {
            delete person.activatedOnUserScreen;
        }

        this.props.actions.saveUser(person, this.props.config, this);
    };

    handleClose = () => {
        this.setState({ openDialog: false, message: "" });
    }

    render() {
        const {
            addLink,
            columns,
            columnOrder,
            columnWidths,
            currentPage,
            filterByOptions,
            initialValues,
            loading,
            pageSize,
            pageSizes,
            rows,
            searchByOptions,
            sorting,
            tableColumnExtensions,
            title,
            productFilterOptions,
            message,
            openDialog,
            refreshed
        } = this.state;

        return (
            <Layout
                className="App"
                showMenu
                menuTitle=""
                toolTip="Having problems? Please review the information you have entered to be sure everything is correct.  If you continue to have problems please contact our Customer Service department at (205) 414-2727."
            >
                <Paper style={paperStyle}>
                    {loading && <LinearProgress className="linear-progress-top" />}
                    <Grid
                        rows={rows}
                        columns={columns}
                        getRowId={this.getRowId}
                    >
                        {
                            message !== '' ? <RenderDialog
                                open={openDialog}
                                confirmButton
                                message={message}
                                onClose={this.handleClose}
                            /> : <div />
                        }
                        <TableFilters
                            addLink={addLink}
                            changeFilters={this.changeFilters}
                            filterByOptions={filterByOptions}
                            initialValues={initialValues}
                            searchByOptions={searchByOptions}
                            title={title}
                            productFilterOptions={this.props.person && isSysAdmin(this.props.person) ? productFilterOptions : []}
                            showCloseEnd
                        />

                        {!refreshed && this.props.customers ? this.props.actions.getUsers(this.props.config, this.props.customers.customers, this.props.locationsList.data, this.props.persons, this) : null}


                        {filterByOptions && <IntegratedFiltering />}

                        <SortingState
                            sorting={sorting}
                            onSortingChange={this.changeSorting}
                        />

                        <PagingState
                            currentPage={currentPage}
                            onCurrentPageChange={this.changeCurrentPage}
                            pageSize={pageSize}
                            onPageSizeChange={this.changePageSize}
                        />

                        <IntegratedSorting />

                        <IntegratedPaging />

                        <DragDropProvider />

                        <Table
                            columnExtensions={tableColumnExtensions}
                            cellComponent={this.cell}
                        />

                        <TableColumnReordering
                            order={columnOrder}
                            onOrderChange={this.changeColumnOrder}
                        />

                        <TableColumnResizing
                            columnWidths={columnWidths}
                            onColumnWidthsChange={this.changeColumnWidths}
                        />

                        <TableHeaderRow
                            showSortingControls
                        />

                        <PagingPanel pageSizes={pageSizes} />
                    </Grid>
                </Paper>
            </Layout>
        );
    }
}

const reduxToProps = state => ({
    config: state.config.config,
    person: state.person.person,
    persons: state.search.persons,
    personLocations: state.search.personlocations,
    customers: state.customers.customers,
    locationsList: state.search.locationsList
});

const dispatchToProps = dispatch => ({
    actions: {
        getUserData: async (config, self) => {
            await dispatch(getCustomerGroups(config));
            await dispatch(search('person-locations', 0, null, config))
            await dispatch(search('locations', 0, null, config, true));
            await dispatch(getCustomers(config));
            await dispatch(search('persons', 0, null, config));
            await dispatch(getReportTypes(config));
        },
        getUsers: (config, customerItems, locationsList, personsList, self) => {
            const isATSysAdmin = isUserATSysAdmin(localStorage.getItem('customerId'));
            const product = ProductMap[sessionStorage.getItem('product')];
            const customers = filterCustomersByProduct(product, customerItems, localStorage.getItem('customerId'), isATSysAdmin);
            self.setState({ allCustomers: customers });
            self.setState({ allLocations: locationsList });
            let locations = locationsList;
            locations = filterLocationsByProduct(locations, customers);
            const personLocationsResult = self.props.personLocations;
            let personLocations = {};
            if (personLocationsResult && personLocationsResult.data) {
                personLocations = personLocationsResult.data;
                self.setState({ allPersonLocations: personLocations });
                const personLocationsFilteredByProduct = filterPersonLocationsByProduct(personLocations, locations);

                let persons = [];

                if (personsList && personsList.data) {
                    persons = personsList.data;
                }
                let rows = [];
                self.setState({ allPersons: persons });

                persons = filterUsersByProduct(persons, personLocations, personLocationsFilteredByProduct, isATSysAdmin);
                rows = persons.map(self.rowMapper);

                if (self.props.location.pathname.includes('/location/')) {
                    const locationId = self.props.match.params.id;

                    personLocations = personLocations.filter(pl => pl.locationId === locationId);

                    persons = persons.filter(p => personLocations.some(pl => pl.personId === p.personId));
                    rows = persons.map(self.rowMapper);

                    self.setState({ loading: false, allItems: persons, rows }, () => {
                        self.reapplyTableOptions();
                    });

                } else {
                    rows = persons.map(self.rowMapper);

                    self.setState({ loading: false, allItems: persons, rows }, () => {
                        self.reapplyTableOptions();
                    });
                }
                self.setState({ refreshed: true });
            }
        },
        saveUser: (user, config, self) => {
            self.setState({ loading: true });

            dispatch(updatePerson(user, config)).then(() => {
                dispatch(search('persons', 0, null, config));
                dispatch(getCustomers(config));
            });
        },
    }
});

const ConnectedComponent = connect(reduxToProps, dispatchToProps)(UserList);

export default (reduxForm({ form: 'UserList' })(ConnectedComponent));


// WEBPACK FOOTER //
// ./src/components/Customer/User/UserList.js